import styled from 'styled-components';

export const Container = styled.div`
  height: 2px;
  background-color: #ebebeb;
`;
